import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import authService from '../../services/authService';
import './VerifyEmail.css';

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const token = searchParams.get('token');

        if (!token) {
          setError('Invalid verification link. Token not found.');
          setLoading(false);
          return;
        }

        const response = await authService.verifyEmail(token);

        if (response && response.success) {
          setSuccess(true);
          setError('');

          // Redirect to login after 3 seconds
          setTimeout(() => {
            navigate('/login', {
              state: { message: 'Email verified successfully! You can now sign in.' }
            });
          }, 3000);
        } else {
          setError(response?.message || 'Email verification failed. Please try again.');
          setSuccess(false);
        }
      } catch (err) {
        setError(err.message || 'An error occurred during email verification. Please try again.');
        setSuccess(false);
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div className="verify-email-container">
      <div className="verify-card">
        {/* Optional Header */}
        <div className="verify-header">
          <h1 className="verify-logo">AI Recruitment System</h1>
          <p className="verify-tagline">Hire smarter with AI-powered candidate evaluation</p>
        </div>

        {/* Loading State */}
        {loading && (
          <div className="verify-state">
            <div className="verify-icon loading-icon">
              <svg className="spinner" viewBox="0 0 50 50">
                <circle
                  className="spinner-circle"
                  cx="25"
                  cy="25"
                  r="20"
                  fill="none"
                ></circle>
              </svg>
            </div>
            <h2 className="verify-title">Verifying Your Email</h2>
            <p className="verify-message">
              Please wait while we confirm your email address...
            </p>
          </div>
        )}

        {/* Success State */}
        {success && !loading && (
          <div className="verify-state">
            <div className="verify-icon success-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <polyline points="20 6 9 17 4 12" strokeLinecap="round" strokeLinejoin="round"></polyline>
              </svg>
            </div>
            <h2 className="verify-title success-title">✅ Email Verified!</h2>
            <p className="verify-message">
              Your email has been successfully verified. You can now access all features of the AI Recruitment System.
            </p>
            <div className="redirect-progress">
              <div className="progress-bar"></div>
            </div>
            <p className="redirect-text">Redirecting to sign in...</p>
          </div>
        )}

        {/* Error State */}
        {error && !loading && !success && (
          <div className="verify-state">
            <div className="verify-icon error-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" strokeLinecap="round" strokeLinejoin="round"></circle>
                <line x1="15" y1="9" x2="9" y2="15" strokeLinecap="round" strokeLinejoin="round"></line>
                <line x1="9" y1="9" x2="15" y2="15" strokeLinecap="round" strokeLinejoin="round"></line>
              </svg>
            </div>
            <h2 className="verify-title error-title">❌ Verification Failed</h2>
            <p className="error-message">{error}</p>

            <div className="verify-actions">
              <Link to="/login" className="btn-primary-verify">
                Go to Sign In
              </Link>
              <Link to="/signup" className="btn-secondary-verify">
                Create New Account
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;